import React from 'react';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import MessagesDetailCard from './MessagesDetailCard';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export default class MessageDetailScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MESSAGES,
            {
                ...Breadcrumbs.MESSAGES_DETAIL,
                url: props.location.pathname,
                loading: false,
                description: I18nUtils.tr('TR_CONVERSACION'),
            },
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { id } = this.props.match.params;

        return (
            <PsPage title={I18nUtils.tr('TR_CONVERSACION')} breadcrumbs={breadcrumbs}>
                <MessagesDetailCard key={id} messageId={id}/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/detail/MessageDetailScreen.js